/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PricingPlanResource
 */
export interface PricingPlanResource {
    /**
     * 
     * @type {string}
     * @memberof PricingPlanResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PricingPlanResource
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PricingPlanResource
     */
    fees: string;
    /**
     * 
     * @type {boolean}
     * @memberof PricingPlanResource
     */
    automatic: boolean;
}

/**
 * Check if a given object implements the PricingPlanResource interface.
 */
export function instanceOfPricingPlanResource(value: object): value is PricingPlanResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('fees' in value) || value['fees'] === undefined) return false;
    if (!('automatic' in value) || value['automatic'] === undefined) return false;
    return true;
}

export function PricingPlanResourceFromJSON(json: any): PricingPlanResource {
    return PricingPlanResourceFromJSONTyped(json, false);
}

export function PricingPlanResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PricingPlanResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'fees': json['fees'],
        'automatic': json['automatic'],
    };
}

export function PricingPlanResourceToJSON(value?: PricingPlanResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'fees': value['fees'],
        'automatic': value['automatic'],
    };
}

